import { render, staticRenderFns } from "./processing-list-events.vue?vue&type=template&id=ec4da32e&scoped=true"
import script from "./processing-list-events.vue?vue&type=script&lang=js"
export * from "./processing-list-events.vue?vue&type=script&lang=js"
import style0 from "./processing-list-events.vue?vue&type=style&index=0&id=ec4da32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4da32e",
  null
  
)

export default component.exports